
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfessionalListItemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NewPerson"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seoName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"memoHtml"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"score"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scoreCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"answerCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"profilePhotoId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"photoCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isActive"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"professionSeoName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professionSeoName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"professionTaskSeoName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professionTaskSeoName"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"citySeoName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"citySeoName"}}}]}}],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inactiveUntil"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"publicPhoneNumber"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PhoneNumberFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"winCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceByProfessionTask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"professionTaskSeoName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"professionTaskSeoName"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"priceType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceFrom"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"priceTo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"professionTask"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seoName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parentCityId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countyId"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"professions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seoName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"online"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"labels"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isBadge"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":836}};
    doc.loc.source = {"body":"#import \"~/graphql/fragments/phoneNumberFragment.graphql\"\n\nfragment ProfessionalListItemFragment on NewPerson {\n  id\n  name\n  seoName\n  memo\n  memoHtml\n  score\n  scoreCount\n  answerCount\n  profilePhotoId\n  photoCount\n  isActive(\n    input: {\n      professionSeoName: $professionSeoName\n      professionTaskSeoName: $professionTaskSeoName\n      citySeoName: $citySeoName\n    }\n  )\n  inactiveUntil\n  publicPhoneNumber {\n    ...PhoneNumberFragment\n  }\n  winCount\n  priceByProfessionTask(professionTaskSeoName: $professionTaskSeoName) {\n    priceType\n    price\n    priceFrom\n    priceTo\n    professionTask {\n      id\n      name\n      unit\n    }\n  }\n  city {\n    id\n    name\n    seoName\n    parentCityId\n    countyId\n  }\n  professions {\n    id\n    seoName\n    name\n    online\n  }\n  labels {\n    id\n    name\n    description\n    isBadge\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/phoneNumberFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProfessionalListItemFragment"] = oneQuery(doc, "ProfessionalListItemFragment");
        
